import { RouteConfig } from 'vue-router';

const Login = () => import(/* webpackChunkName: "Access" */  './views/login/login.vue');
const Register = () => import(/* webpackChunkName: "Access" */  './views/register/register.vue');



const routers: RouteConfig[] = [
    {
        path: 'login',
        name: 'login',
        component: Login
    },
    {
        path: 'register',
        name: 'register',
        component: Register
    },
    {
        path: '',
        redirect: 'login'
    },
];

export default routers;

